import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51b2445b")

_pushScopeId("data-v-51b2445b")
const _hoisted_1 = { class: "m-toast" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("p", null, [
        _createVNode("img", {
          class: "icon",
          src: _ctx.iconSrc
        }, null, 8, ["src"]),
        _createTextVNode(_toDisplayString(_ctx.htmlString), 1)
      ])
    ], 512), [
      [_vShow, _ctx.visible]
    ])
  ]))
})